import React, { useState, useEffect } from "react";
import { Row, Col, Form, Input, Checkbox, Select, DatePicker } from "antd";
import { HeaderWithBottomLine } from "../HeaderWithBottomLine";
import {
  checkNumbervalue,
  checkSpecialCharacter,
  checkSpace,
} from "../../../../utils";

function PersonalAddress({ form, setLoading, disabledDateNext, check }) {
  const [materialStatus, setMaterialStatus] = useState("");
  const [apiError, setApiError] = useState({});
  const [apiError1, setApiError1] = useState({});

  const [checked, setChecked] = useState(false);

  const [sameAsPersonal, setSameAsPersonal] = useState(true);

  useEffect(() => {
    setChecked(false);
  }, [check]);

  const getPinCodeDetails = async (e, name) => {
    setChecked(false);
    setSameAsPersonal(false);
    if (e.target.value.length > 5) {
      setLoading(true);
      try {
        let response = await fetch(
          `https://api.postalpincode.in/pincode/${e.target.value}`
        );
        let res = await response.json();
        if (res[0]?.Status == "Success") {
          {
            res?.map((data) => {
              data?.PostOffice?.map((data) => {
                if (name == "PINCode") {
                  form.setFieldsValue({
                    City: data?.District,
                    State: data?.State,
                  });
                  setApiError({
                    validateStatus: "success",
                    errorMsg: null,
                  });
                  // setSameAsPersonal(false);
                } else {
                  setChecked(false);
                  form.setFieldsValue({
                    City1: data?.District,
                    State1: data?.State,
                    checkbox: false,
                  });
                  setApiError1({
                    validateStatus: "success",
                    errorMsg: null,
                  });
                }
              });
            });
          }
          setLoading(false);
        } else if (res[0]?.Status == "Error") {
          setLoading(false);
          if (name == "PINCode") {
            setApiError({ validateStatus: "error", errorMsg: res[0]?.Message });
          } else {
            setApiError1({
              validateStatus: "error",
              errorMsg: res[0]?.Message,
            });
          }
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      if (name == "PINCode") {
        form.setFieldsValue({
          City: null,
          State: null,
        });
      } else {
        form.setFieldsValue({
          City1: null,
          State1: null,
        });
      }
    }
  };

  const handleCheckboc = (e) => {
    const a = form.getFieldsValue();
    setChecked(e.target.checked);
    if (e.target.checked) {
      form.setFieldsValue({
        PINCode1: a.PINCode,
        City1: a.City,
        State1: a.State,
        ResidentialAddressLine10: a.ResidentialAddressLine1,
        ResidentialAddressLine20: a.ResidentialAddressLine2,
      });
    } else {
      form.setFieldsValue({
        PINCode1: "",
        City1: "",
        State1: "",
        ResidentialAddressLine10: "",
        ResidentialAddressLine20: "",
      });
    }
  };

  const handlerChange = () => {
    // console.log(e);
    setChecked(false);

    const a = form.getFieldsValue();
    if (a?.PINCode !== "" && a.ResidentialAddressLine1 !== "") {
      setSameAsPersonal(false);
    } else {
      setSameAsPersonal(true);
    }
  };

  const handlerChange2 = () => {
    setChecked(false);
  };

  let lg = 12;
  let sm = 12;
  let md = 12;
  let xs = 24;

  function validateInput(rule, value, callback) {
    if (/^\s/.test(value)) {
      callback("Input cannot start with a space!");
    } else {
      callback();
    }
  }

  function validatePincode(rule, value, callback) {
    console.log(value);
    if (!/^[1-9][0-9]{5}$/.test(value)) {
      callback("Please enter a valid pincode!");
    } else {
      callback();
    }
  }
  return (
    <>
      <HeaderWithBottomLine text={"Residential Address"} icon={false} />
      <Row gutter={40} className="basic-details-conten global-form-row">
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="ResidentialAddressLine1"
            label={"Address line 1"}
            rules={[
              {
                required: true,
                message: "Please enter address",
              },
              { validator: validateInput },
            ]}
          >
            <Input
              placeholder="Enter address"
              type="text"
              onChange={handlerChange}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="ResidentialAddressLine2"
            label={"Address line 2"}
            rules={[{ validator: validateInput }]}
          >
            <Input
              placeholder="Enter address"
              type="text"
              onChange={handlerChange2}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="PINCode"
            label={"PIN code"}
            validateStatus={apiError?.validateStatus}
            help={apiError?.errorMsg}
            rules={[
              {
                required: true,
                message: "Please enter pincode",
              },
              {
                pattern: /^([0-9]){6}$/g,
                message: "Invalid pincode number",
              },
            ]}
            onKeyPress={(event) => {
              if (
                checkNumbervalue(event) ||
                checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
          >
            <Input
              placeholder="Enter pincode"
              type="text"
              maxLength={6}
              onChange={(e) => getPinCodeDetails(e, "PINCode")}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item name="City" label={"City"}>
            <Input
              placeholder="City name"
              type="text"
              maxLength={20}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item name="State" label={"State"}>
            <Input
              placeholder="State name"
              type="text"
              maxLength={20}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="contactNumber"
            label={"Contact number"}
            rules={[
              {
                required: true,
                message: "Please enter contact number",
              },
              {
                pattern: /^([1-9]{1}[0-9]{9}){0,10}$/g,
                message: "Invalid contact number",
              },
            ]}
            onKeyPress={(event) => {
              if (
                checkNumbervalue(event) ||
                checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
          >
            <Input
              placeholder="Enter Contact Number"
              type="text"
              maxLength={10}
              // disabled={true}
            />
          </Form.Item>
        </Col>
      </Row>
      <HeaderWithBottomLine text={"Permanent Address"} icon={false} />
      <Row gutter={40} className=" global-form-row">
        <Col lg={24}>
          <Form.Item
            name="checkbox"
            className="personal-checkbox"
            // label={"State"}
          >
            <Checkbox
              onChange={(e) => handleCheckboc(e)}
              disabled={sameAsPersonal}
              checked={checked}
            >
              Same as residential address
            </Checkbox>
          </Form.Item>
        </Col>

        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="ResidentialAddressLine10"
            label={"Address line 1"}
            rules={[
              {
                required: true,
                message: "Please enter address",
              },
              { validator: validateInput },
            ]}
          >
            <Input
              placeholder="Enter address"
              type="text"
              maxLength={20}
              onChange={handlerChange2}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="ResidentialAddressLine20"
            label={"Address line 2"}
            rules={[{ validator: validateInput }]}
          >
            <Input
              placeholder="Enter address"
              type="text"
              maxLength={20}
              onChange={handlerChange2}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="PINCode1"
            label={"PIN code"}
            validateStatus={apiError1?.validateStatus}
            help={apiError1?.errorMsg}
            rules={[
              {
                required: true,
                message: "Please enter pincode",
              },
              {
                pattern: /^([0-9]){6}$/g,
                message: "Invalid pincode number",
              },
            ]}
            onKeyPress={(event) => {
              if (
                checkNumbervalue(event) ||
                checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
          >
            <Input
              placeholder="Enter pincode"
              type="text"
              maxLength={6}
              onChange={(e) => getPinCodeDetails(e, "1PINCode")}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item name="City1" label={"City"}>
            <Input
              placeholder="City name"
              type="text"
              maxLength={20}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item name="State1" label={"State"}>
            <Input
              placeholder="State name"
              type="text"
              maxLength={20}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}></Col>

        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="EducationalQualification"
            label={
              <span className="calculater-container-pikpin">
                Educational qualification
              </span>
            }
            className="input-drop-down"
          >
            <Select
              // className="app-selector"
              placeholder="Select educational qualification "
              options={[
                {
                  value: "Primary School",
                  label: "Primary School",
                },
                {
                  value: "Secondary School",
                  label: "Secondary School",
                },
                {
                  value: "Diploma",
                  label: "Diploma",
                },
                {
                  value: "Bachelor's degree",
                  label: "Bachelor's degree",
                },
                {
                  value: "Master's degree",
                  label: "Master's degree",
                },
                {
                  value: "PhD",
                  label: "PhD",
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="MarriageStatus"
            label={
              <span className="calculater-container-pikpin">
                Martial status
              </span>
            }
            // rules={[
            //   {
            //     required: true,
            //     message: "Please select value",
            //   },
            // ]}
          >
            <Select
              placeholder="Select martial status "
              className="app-selector"
              onChange={(e) => setMaterialStatus(e)}
              options={[
                {
                  value: "Single",
                  label: "Single",
                },
                {
                  value: "Married",
                  label: "Married",
                },
              ]}
            />
          </Form.Item>
        </Col>

        {materialStatus == "Married" && (
          <Col lg={lg} md={md} sm={sm} xs={xs}>
            <Form.Item
              name="MarriageDate"
              label={"Marriage date"}
              // rules={[
              //   {
              //     required: true,
              //     message: "Please enter value",
              //   },
              // ]}
            >
              <DatePicker
                style={{
                  width: "100%",
                  background: "#f7f7f7",
                  border: "none",
                  borderRadius: "6px",
                  height: "40px",
                }}
                size={"small"}
                format={"DD-MM-YYYY"}
                placeholder={"DD/MM/YYYY"}
                disabledDate={disabledDateNext}
              />
            </Form.Item>
          </Col>
        )}
      </Row>
    </>
  );
}

export default PersonalAddress;
